export default {
  pleaseEnterEmail: "Please, enter the email you use to sign in.",
  pleaseCheckInboxAndClickLink: "Please, check your inbox and click in the received link to reset a password.",
  didYouReceiveTheLink: "Didn't receive the link?",
  linkHasBeenResent: "The link has been resent!",
  pleaseEnterNewPassword: "Please, enter your new password.",
  enterCodeAndNewPassword: "Please, enter the code from received e-mail and new password.",
  signInWithNewPassword: "Please, sign in with new password.",
  mailShouldBeRegistered: "E-mail should be registered in the system.",
  instructionsWillBeSent: "Further instructions will be sent to your email.",
  passwordMust: "Password Must",
  passwordRules: [
    "Be at least 8 characters.",
    "Have at least 1 upper case character.",
    "Have at least 1 numerical character.",
    "Have at least 1 symbol.",
  ],
  defaultAlertMessage: {
    error: "Unknown error occurred.",
    info: "Success.",
    success: "Success.",
  },
  noData: "Empty data",
  noChart: "Unknown chart type, please re-create the chart.",
  errorGetData: "Error get data.",
  errorGetFiltersData: "Error get filters data.",
  errorGetSummaryData: "Error get summary data.",
  errorGetTableData: "Error get table data.",
  errorGetFormData: "Error get form data.",
  errorGetTemplates: "Error get templates",
  errorCreateTemplate: "Error create new template.",
  errorUpdateTemplate: "Error update template.",
  errorCreateTenant: "Error create tenant.",
  errorEditTenant: "Error edit tenant.",
  errorGetCatalogs: "Error get catalogs.",
  errorGetUserSettings: "Error get user settings.",
  settingsLoadError: "Couldn't load your settings. Please refresh the page. If the problem persists, contact IT.",
  errorGetAdvertisers: "Error get advertisers.",
  errorSaveUserSettings: "Error save user settings.",
  errorAddNewPage: "Error add new page.",
  errorUpdatePage: "Error update page.",
  errorDeleteSettings: "Error delete settings.",
  errorGetTenants: "Error get tenants.",
  errorDisableEnableTenant: "Error disable/enable tenant.",
  errorGetAgencies: "Error get agencies.",
  errorFailedToDecodeProjectOutputLayout: "Failed to decode project output layout.",
  errorFailedToLoadData: "Failed to load data.",
  errorFailedToCheckProjectLayout: "Failed to check project layout.",
  errorFailedToEstimateAudience: "Failed to estimate audience size.",
  errorFailedToSavePlan: "Failed to save plan.",
  errorFailedToRecalculatePlan: "Failed to recalculate plan.",
  errorRecalculateTooLarge: "Recalculation is too large to process. Try reducing the number of plans or channels.",
  errorSaveProject: "Error saving project.",
  errorMovePlan: "The plan was saved but could not be moved to the selected business goal.",
  errorFailedToStartGeneration: "Failed to start generation.",
  errorGetTenant: "Error get tenant.",
  errorGetUsers: "Error get users.",
  errorEnableUser: "Error enable user.",
  errorDisableUser: "Error disable user.",
  errorSaveUser: "Error save user.",
  errorUpdateUser: "Error update user.",
  errorResetPassword: "Error send invite.",
  errorRestorePasswordAttemptsLimitExceeded:
    "Password restore attempts limit exceeded, please try again after some time.",
  errorRestorePasswordUnexpected: "Unexpected error when try to restore password.",
  errorInvalidEmailOrPassword: "Invalid email or password.",
  dashboardCreated: (dashboardName: string) => {
    return `Dashboard "${dashboardName}" was successfully created.`;
  },
  planCreated: (planName: string) => {
    return `Plan "${planName}" was successfully created.`;
  },
  planUpdated: (planName: string) => {
    return `Plan "${planName}" was successfully updated.`;
  },
  planNameTakenInBusinessGoal: (planName: string, businessGoalName: string) => {
    return `Plan "${planName}" already exists in business goal "${businessGoalName}".`;
  },
  projectOutputCreated: (projectName: string) => {
    return `Output generation for  "${projectName}" was successfully initiated.`;
  },
  projectOutputNotCreated: (projectName: string) => {
    return `Error occurred when output for "${projectName}" was created.`;
  },
  dashboardNotCreated: (dashboardName: string) => {
    return `Error occurred when dashboard "${dashboardName}" was created.`;
  },
  planNotCreated: (planName: string) => {
    return `Error occurred when plan "${planName}" was created.`;
  },
  dashboardUpdated: (dashboardName: string) => {
    return `Dashboard "${dashboardName}" was successfully updated.`;
  },
  dashboardReset: (dashboardName: string) => {
    return `Dashboard "${dashboardName}" was successfully reset to initial state.`;
  },
  dashboardNotReset: (dashboardName: string) => {
    return `Error occurred when dashboard "${dashboardName}" was reset to initial state.`;
  },
  dashboardDeleted: (dashboardName: string) => {
    return `Dashboard "${dashboardName}" was successfully removed.`;
  },
  dashboardNotDeleted: (dashboardName: string) => {
    return `Error occurred when dashboard "${dashboardName}" was removed.`;
  },
  dashboardNotUpdated: (dashboardName: string) => {
    return `Error occurred when dashboard "${dashboardName}" was updated.`;
  },
  projectOutputLayoutUpdated: (projectName: string) => {
    return `Output view for "${projectName}" was successfully updated.`;
  },
  projectOutputLayoutNotUpdated: (projectName: string) => {
    return `Error occurred when output view for "${projectName}" was updated.`;
  },
  userAlreadyExists: "User already exists.",
  emptyTenantsList: "Empty tenants list.",
  successCreateTemplate: "Template created successfully.",
  successUpdateTemplate: "Template updated successfully.",
  successPasswordReset: (email: string) => `Invite was successfully resent to ${email}.`,
  successUserCreated: (email: string) => `User with email ${email} created successfully.`,
  successUserUpdated: (email: string) => `User with email ${email} updated successfully.`,
  successTenantCreated: (name: string) => `Tenant ${name} created successfully.`,
  successTemplateDeleted: (name: string) => `Template ${name} successfully deleted.`,
  successTenantUpdated: (name: string) => `Tenant ${name} updated successfully.`,
  successTenantEnabled: "Tenant enabled successfully.",
  successTenantDisabled: "Tenant disabled successfully.",
  successUserEnabled: "User enabled successfully.",
  successUserDisabled: "User disabled successfully.",
  projectOutputGenerationInitiated: "Project output generation initiated.",
  planOutputGenerationStarted: "Plan output generation started.",
  projectUpdated: "Project updated.",
  planReadyToGenerate: "CYRIS received enough data to generate a Plan.",
  pngExportUnavailableInSafari: "PNG export temporary unavailable in Safari.",
  noScenariosFoundForGeneration: "Cannot generate output: No scenarios found on the page.",
  scenarioNotReadyForGeneration:
    "Cannot generate output: Scenario data is incomplete or invalid. Edit the Plan to fix it.",
  noJobIdReturned: "No jobId returned from API.",
  planGenerationRunningConflict: "Plan generation is running. You cannot modify scenarios for this Project right now.",
  planGenerationAlreadyRunningForSelectedScenarios: "Plan generation already running for selected scenarios.",
  generationFailed: "Generation failed",
  unknownError: "Unknown error",
  notFound: "Not found",
  errorDeleteTemplate: "Error delete template.",
  imageMessageError: "Please select an image file.",
  freshProjectLoadFailed: "Could not load fresh project from server.",
  wrongUserSettingsFormat: "Wrong user settings format.",
  integerValueRequired: "Integer value required",
  exportFailed: "Export failed",
  exportUnavailableInSafari: "Export temporary unavailable in Safari.",
  localProjectUpdatedSaveLayout: "Local Project updated. Save layout to persist changes.",
  noSelectedProjectFound: "No selected project found",
  invalidProjectSelected: "Invalid project selected",
  projectDataCouldNotBeLoaded: "Project data could not be loaded",
  failedToAddBusinessGoalToProject: "Failed to add business goal to project",
  projectAccessUpdated: "Project access updated successfully",
  errorUpdatingProject: "Error updating project",
  failedToStartOutputGeneration: "Failed to start output generation",
  onlyOneScenarioCanBeApproved: "Only one Scenario per Plan can be approved.",
  nothingToApprove: "Nothing to approve. Selected scenarios are already approved or none selected.",
  selectTwoScenariosForComparison: "To run comparison select at least two scenarios within the same plan.",
  loadingComparison: "Loading comparison...",
  enterAtLeastThreeCharsToSearch: "Please enter at least 3 characters to search",
  cannotGenerateNoScenariosFound: "Cannot generate output: No scenarios found.",
};
